/* GetZget v2 look (trial), every gzt page: hero arrows + progress bar, and sections that fade up as they scroll into view. */
(function(){
  var b=document.body;if(!b||!b.classList.contains('gzt'))return;
  var H=document.documentElement;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design=window.Shopify&&window.Shopify.designMode;

  var hero=document.querySelector('.gzt-hero');
  if(hero){
    var sp=parseInt(hero.getAttribute('data-speed'),10)||5000;
    hero.style.setProperty('--gzv-speed',sp+'ms');
    if(hero.getAttribute('data-auto')==='true')hero.classList.add('gzv-auto');
    var dots=[].slice.call(hero.querySelectorAll('.gzt-dots button'));
    if(dots.length>1&&!hero.querySelector('.gzv-arrows')){
      var ar='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M';
      var nav=document.createElement('div');nav.className='gzv-arrows';
      nav.innerHTML='<button type="button" aria-label="Previous slide" data-d="-1">'+ar+'15 5l-7 7 7 7"/></svg></button><button type="button" aria-label="Next slide" data-d="1">'+ar+'9 5l7 7-7 7"/></svg></button>';
      hero.appendChild(nav);
      nav.addEventListener('click',function(e){
        var t=e.target.closest&&e.target.closest('button');if(!t)return;
        var c=0;dots.forEach(function(d,i){if(d.getAttribute('aria-current')==='true')c=i;});
        dots[(c+parseInt(t.getAttribute('data-d'),10)+dots.length)%dots.length].click();
      });
    }
  }

  if(reduce||design||!('IntersectionObserver' in window))return;
  var vh=window.innerHeight||800;
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(!e.isIntersecting)return;
      var el=e.target;io.unobserve(el);el.classList.add('is-in');
      setTimeout(function(){
        el.removeAttribute('data-gzv');el.classList.remove('is-in');
        [].forEach.call(el.querySelectorAll('[data-gzv-k]'),function(k){k.removeAttribute('data-gzv-k');k.style.removeProperty('--i');});
      },1700);
    });
  },{rootMargin:'0px 0px -10% 0px',threshold:0.01});
  /* animate whole sections, or blocks inside one long section (product page, collection page) */
  var units=[];
  [].forEach.call(document.querySelectorAll('main > .shopify-section'),function(s,idx){
    if(idx===0&&s.querySelector('.gzt-hero'))return;
    if(s.querySelector('.gzt-hero,.gzs__stage,.gzt-coupons'))return;
    var kids=s.querySelectorAll(':scope > .gzt-sec, :scope > .gzt-trust, :scope > .gzp-desc, :scope > section');
    if(kids.length>1){[].forEach.call(kids,function(k){units.push(k);});}else{units.push(s);}
  });
  var any=false;
  units.forEach(function(u){
    if(u.offsetHeight<4||u.getBoundingClientRect().top<vh*0.92)return;
    u.setAttribute('data-gzv','');any=true;
    [].forEach.call(u.querySelectorAll('.gzt-grid,.gzt-scene:not([hidden]),.gzt-devices,.gzt-trust,.gzb-grid,.gzl'),function(g){
      [].forEach.call(g.children,function(k,i){k.setAttribute('data-gzv-k','');k.style.setProperty('--i',Math.min(i,7));});
    });
    if(u.classList.contains('gzt-trust')){[].forEach.call(u.children,function(k,i){k.setAttribute('data-gzv-k','');k.style.setProperty('--i',Math.min(i,7));});}
    io.observe(u);
  });
  if(any)H.classList.add('gzv');
})();
